<div class="custom-datepicker">
  <button mat-icon-button (click)="decrementDay()">
    <mat-icon>chevron_left</mat-icon>
  </button>

  <button mat-stroked-button color="primary" matTooltip="Modo de vista" cdkOverlayOrigin #trigger="cdkOverlayOrigin"
    (click)="calendarVisibility(!isViewMenuOpen())">
    <div class="flex items-center">
      <div class="pr-2">
        <mat-icon svgIcon="calendar_today"></mat-icon>
      </div>
      <div class="flex flex-col p-2 content-center text-center gap-[3px] min-w-[60px] w-20">
        <span class="font-light">{{title ? title : 'Fecha'}}</span>
        <small class="font-bold">{{ date() | date:'mediumDate' }}</small>
      </div>

      <mat-icon [svgIcon]="isViewMenuOpen() ? 'arrow_drop_up' : 'arrow_drop_down'"></mat-icon>
    </div>
  </button>

  <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isViewMenuOpen()"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayHasBackdrop]="true"
    (detach)="calendarVisibility(false)"
    (backdropClick)="calendarVisibility(false)"
    >
    <div class="w-[253px] h-[304px] w-min-[253px] h-min-[304px] p-4 bg-white shadow-lg rounded-lg">
      <mat-calendar #calendar [selected]="date()" (selectedChange)="onDateChange($event)" [startAt]="date()"></mat-calendar>
    </div>
  </ng-template>

  <button mat-icon-button (click)="incrementDay()">
    <mat-icon>chevron_right</mat-icon>
  </button>

</div>
